import isNumber from 'utilities/isNumber';

import { getAgentNpn } from './getSessionData';

const deleteJSON = async ({ body, url }) => {
    const agentNpn = getAgentNpn();
    const options = {
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
            ...(isNumber(agentNpn) && { isPurl: true }),
            ...(agentNpn && { AgentNPN: agentNpn })
        },
        method: 'DELETE'
    };

    const response = await fetch(url, options);

    return response || '';
};

export default deleteJSON;
